import React from 'react';
import PropTypes from 'prop-types';

class FavouriteUpdateListener extends React.Component {
  componentDidMount() {
    const { showPlanningEnabled } = this.props;

    if (showPlanningEnabled) {
      if (window && window.showPlanningReduxDispatcher) {
        window.showPlanningReduxDispatcher.subscribe(() => {
          const updatedParticipantList = window.showPlanningReduxDispatcher.getState().participantReducer;
          if (updatedParticipantList.newParticipant || updatedParticipantList.oldParticipant) {
            this.changeShowPlan(updatedParticipantList);
          } else {
            this.props.favouriteCallback(this.props.showPlan);
          }
        });
      }
    }
  }

  addParticipantToShowPlan = (participationId) => {
    if (this.props.showPlan.participationIds.indexOf(participationId) === -1) {
      this.props.showPlan.participationIds.push(participationId);
      this.props.favouriteCallback(this.props.showPlan);
    }
  };

  removeParticipantFromShowPlan = (participationId) => {
    const index = this.props.showPlan.participationIds.indexOf(participationId);
    if (index !== -1) {
      this.props.showPlan.participationIds.splice(index, 1);
      this.props.unfavouriteCallback(this.props.showPlan);
    }
  };

  changeShowPlan = (data) => {
    if (data.newParticipant) {
      this.addParticipantToShowPlan(data.newParticipant.participationId);
    } else if (data.oldParticipant) {
      this.removeParticipantFromShowPlan(data.oldParticipant.participationId);
    }
  };

  render() {
    return null;
  }
}

FavouriteUpdateListener.propTypes = {
  showPlanningEnabled: PropTypes.bool,
  showPlan: PropTypes.shape({
    participationIds: PropTypes.arrayOf(PropTypes.string)
  }),
  favouriteCallback: PropTypes.func,
  unfavouriteCallback: PropTypes.func
};

export default FavouriteUpdateListener;
